import { render, staticRenderFns } from "./CartItems.vue?vue&type=template&id=0890b054&scoped=true&"
import script from "./CartItems.vue?vue&type=script&lang=js&"
export * from "./CartItems.vue?vue&type=script&lang=js&"
import style0 from "./CartItems.vue?vue&type=style&index=0&id=0890b054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890b054",
  null
  
)

export default component.exports